import React from 'react';
import { Flex } from '@withjoy/joykit';
import { PriceRange } from '../../../PriceRange/PriceRange';
import { RefinementFacetProps } from '../../RefinementFacet.types';
import { RefinementFacetBase } from '../RefinementFacetBase';
import { RefinementFacetPriceBuckets } from '../RefinementFacetPriceBuckets';
import { useRefinementFacetPriceRange } from './RefinementFacetPriceRange.controller';

export interface RefinementFacetPriceRangeProps extends RefinementFacetProps {}

const RefinementFacetPriceRange = (props: RefinementFacetPriceRangeProps) => {
  const { currentBucketOptions, handleBucketChange, currentPriceRange, handlePriceChange } = useRefinementFacetPriceRange(props);

  return (
    <RefinementFacetBase
      title={'Price'}
      groupCode={props.filter.attributeGroup.code}
    >
      <Flex
        flexDirection="column"
        paddingLeft={5}
        rowGap={6}
      >
        <RefinementFacetPriceBuckets
          options={currentBucketOptions}
          onChange={handleBucketChange}
        />
        <PriceRange
          onChange={handlePriceChange}
          value={currentPriceRange}
        />
      </Flex>
    </RefinementFacetBase>
  );
};

export { RefinementFacetPriceRange };
